import React, { useEffect, useRef, useState } from 'react';

import { useI18next } from '../../../../../plugins/gatsby-plugin-ap-i18next/src/useI18next';
import {
    widgetBox,
    icon,
    bubble
} from './widget-box.module.scss';
import styles from './widget-box.module.scss';

import Section from '../../../molecules/section';
import getTranslationKey from '../../../../utils/get-translation-key';
import Link from '../../../atoms/link';
import SectionWrapper from '../../../molecules/section-wrapper';
import useIntersectionObserver from '../../../../hooks/useIntersectionObserver';
import Button from '../../../atoms/button';
import ButtonWand from '../../../molecules/button-wand';
import Wand from '../../../../assets/images/svg/wand-widget.svg';
import { navigate } from "@reach/router";

export interface WidgetBoxProps {
    className?: string
    alwaysVisible?: boolean;
}

export default function WidgetBox({ className, alwaysVisible = false }: WidgetBoxProps) {
    const widgetRef = useRef<HTMLDivElement>(null);
    const { t } = useI18next();
    const [isVisible, setIsVisible] = useState(alwaysVisible);


    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            const screenHeight = window.innerHeight; // Pobierz wysokość ekranu
            const maxOffset = 120000;

            // Ustaw widoczność widgetu po przewinięciu wysokości ekranu
            if (!alwaysVisible) {
                setIsVisible(scrollY > screenHeight);
            }

            // Oblicz pozycję widgetu
            const top = Math.min(scrollY + screenHeight - 70, maxOffset);

            // Upewnij się, że widget nie znika poniżej ekranu
            if (widgetRef.current) {
                widgetRef.current.style.top = `${Math.max(top, 0)}px`;
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        }
    }, []);

    return (
        isVisible && (<div
            ref={widgetRef} className={`${widgetBox} ${className}`}
            onClick={() => navigate('/generator/wyczaruj-stylizacje')}>
            <div className={icon}>
                <Wand></Wand>
            </div>
            <div className={bubble}>Kliknij i wyczaruj stylizację!</div>
        </div>)
    );
}
